export const ID = 'id';
export const USER_ID = 'userId';
export const CONTACT_ID = 'contactId';
export const F_NAME = 'firstName';
export const L_NAME = 'lastName';
export const COMPANIES = 'companies';
export const IMAGE = 'image';
export const IMAGE_RESET = 'imageReset';
export const EMAIL_WORK = 'emailWork';
export const EMAIL_PERSONAL = 'emailPersonal';
export const EMAIL_OTHER = 'emailOther';
export const CONTACT_TYPES = 'contactTypes';
export const PHONE_WORK = 'phoneWork';
export const PHONE_MOBILE = 'phoneMobile';
export const PHONE_OTHER = 'phoneOther';
export const NOTE = 'note';
export const NOTE_RESET = 'noteReset';
export const ADDRESS_WORK = 'addressWork';
export const ADDRESS_WORK_UNIT = 'addressWorkUnit';
export const ADDRESS_WORK_RESET = 'addressWorkReset';
export const ADDRESS_HOME = 'addressHome';
export const ADDRESS_HOME_UNIT = 'addressHomeUnit';
export const ADDRESS_HOME_RESET = 'addressHomeReset';
export const ADDRESS_OTHER = 'addressOther';
export const ADDRESS_OTHER_UNIT = 'addressOtherUnit';
export const ADDRESS_OTHER_RESET = 'addressOtherReset';
export const UNIT = 'unit';
export const LANGUAGES = 'languages';
export const U_NAME = 'username';
export const PWD = 'pwd';
export const CONFIRM_PWD = 'confirmPwd';
export const IS_ENABLED = 'isEnabled';
export const MST_CUST_ID = 'mstCustId';
export const ACCESS_OPTIONS = 'accessOptions';
export const ROLES = 'roles';
export const APPS = 'apps';
export const RESET = 'reset';
export const USER_CONVERT = 'userConvert';
export const ALL_COMPANIES = 'All Companies';
export const POST_LOGIN_APP_ID = 'postLoginAppId';
